import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f5347e9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "recompare-content" }
const _hoisted_2 = { class: "compare-info" }
const _hoisted_3 = { class: "info-row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "当前标的:", -1))
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "info-row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "对比标的:", -1))
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "info-row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "对比部位:", -1))
const _hoisted_11 = { class: "compare-types" }
const _hoisted_12 = { class: "gauges-container" }
const _hoisted_13 = { class: "gauge-wrapper" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gauge-label" }, "原相似度", -1))
const _hoisted_15 = { class: "gauge-wrapper" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gauge-label" }, "新相似度", -1))
const _hoisted_17 = { class: "actions" }

import { ref, computed, watchEffect } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { rebuildPart, saveRebuildResult } from '../../api'
import { useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  __name: 'RecompareDialog',
  props: {
    currentTarget: {
        type: String,
        required: true
    },
    compareTarget: {
        type: String,
        required: true
    },
    currentTargetId: {
        type: String,
        default: ''
    },
    compareTargetId: {
        type: String,
        default: ''
    },
    availableTypes: {
        type: Array,
        required: true
    },
    originalSimilarity: {
        type: Number,
        default: 50
    },
    currentActiveType: {
        type: String,
        required: true
    },
    orderId: {
        type: String,
        default: null
    }
},
  emits: ['start-compare', 'save-result'],
  setup(__props, { emit }) {

const props = __props;

const router = useRouter()





const selectedTypes = ref<string[]>([])
const comparing = ref(false)
const newSimilarity = ref(0)
const hasNewResult = ref(false)

const progressColor = computed(() => {
    return [
        { color: '#f56c6c', percentage: 20 },
        { color: '#e6a23c', percentage: 50 },
        { color: '#67c23a', percentage: 100 }
    ]
})

const toggleType = (type: string) => {
    const index = selectedTypes.value.indexOf(type)
    if (index === -1) {
        selectedTypes.value.push(type)
    } else {
        selectedTypes.value.splice(index, 1)
    }
}

const handleStartCompare = async () => {
    if (selectedTypes.value.length === 0) {
        ElMessage.warning('请至少选择一个对比部位')
        return
    }

    comparing.value = true
    try {
        const params = {
            validateTargetId: props.currentTargetId,
            subjectTargetId: props.compareTargetId,
            runType: 'INSURE',
            parts: selectedTypes.value
        }

        const response = await rebuildPart(params)
        if (typeof response === 'number') {
            newSimilarity.value = response * 100
            hasNewResult.value = true
        } else {
            ElMessage.error('获取相似度失败')
        }
    } catch (error) {
        console.error('对比失败:', error)
    } finally {
        comparing.value = false
    }
}

const handleSaveResult = async () => {
    if (!hasNewResult.value) return

    try {
        const params = {
            orderId: props.orderId,
            validateTargetId: props.currentTargetId,
            subjectTargetId: props.compareTargetId,
            runType: 'INSURE',
            parts: selectedTypes.value,
            similarity: newSimilarity.value / 100
        }

        await saveRebuildResult(params, { noErrorMsg: true })
        emit('save-result', {
            type: selectedTypes.value,
            similarity: newSimilarity.value
        })
        router.go(0)
    } catch (error: any) {
        await ElMessageBox.alert(
            error[0]?.message || '保存失败',
            '错误',
            {
                confirmButtonText: '我知道了',
                type: 'error',
            }
        )
    }
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_progress = _resolveComponent("el-progress")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, _toDisplayString(__props.currentTarget), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("span", _hoisted_8, _toDisplayString(__props.compareTarget), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.availableTypes, (type) => {
            return (_openBlock(), _createBlock(_component_el_button, {
              key: type.value,
              class: _normalizeClass(['type-btn', { active: selectedTypes.value.includes(type.value) }]),
              onClick: ($event: any) => (toggleType(type.value))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(type.label), 1)
              ]),
              _: 2
            }, 1032, ["class", "onClick"]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_el_progress, {
          type: "dashboard",
          percentage: Math.floor(__props.originalSimilarity),
          width: 180,
          "stroke-width": 12,
          color: _unref(progressColor)
        }, null, 8, ["percentage", "color"]),
        _hoisted_14
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_el_progress, {
          type: "dashboard",
          percentage: Math.floor(newSimilarity.value),
          width: 180,
          "stroke-width": 12,
          color: _unref(progressColor)
        }, null, 8, ["percentage", "color"]),
        _hoisted_16
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: handleStartCompare,
        loading: comparing.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 开始对比 ")
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: handleSaveResult,
        disabled: !hasNewResult.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 保存结果 ")
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}
}

})